import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import intl from 'react-intl-universal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import SaveIcon from '@mui/icons-material/Save';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';

class AssignRole extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showassign: false,
            changerole: "",
            changetendant: "",
            have_error: false
          }
    
    }

    handleShowAssignRole = (event) =>{   
        this.setState ({
            showassign: true    
        })
      }

    handleCloseAssignRole = (event) =>{   
        this.setState ({
            showassign: false   
        })
      }

    handleChangeRole = (event) =>{   
        this.setState ({
          changerole: event.target.value    
        })
      }

    handleChangeTendant = (event) =>{   
        this.setState ({
          changetendant: event.target.value    
        })
      }




    handleSubmit = (event,userid) => { 
        event.preventDefault() 
        let json = "";
        json = '{';
        json += '"userId": "' + userid + '",';
        json += '"roleId": "' + this.state.changerole + '",';
        json += '"accountId": "' + this.state.changetendant + '"';
        json += '}';   

        //console.log(json)
        this.adduserrole(this.props.apitoken,userid,json) 
      };      

    adduserrole (token,userid,json)  {
        let apiurl = window.apiurl
        //console.log(json)
        fetch("https://"+apiurl+"/api/User/"+userid+"/addrole", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token,
            },
            body: json
          })
            .then(res => res.json())
            .then(json => {
              console.log("---------------")
              console.log(json)
              console.log("---------------")
              this.props.getuserdata(token, this.props.page + 1, this.props.limit, this.props.sortmode, this.props.sort); 
              this.handleCloseAssignRole() 
            })
            .catch(function(error) {
              console.log(error.status);
            });            
          }
    render () { 
        //console.log(this.props)

       

        let roles = this.props.roles

        const admintenants = this.props.admintenants
        const userdata = this.props.userdata
       
        return (
          <Box  sx={{ p: 2, border: '1px dashed grey' }}>
              {!this.state.showassign &&
              <Fragment>
              <Button
              onClick={() => {
                this.handleShowAssignRole()
              }}
              fullWidth={true}
                variant="outlined"
                sx={{ mt: 1, mb: 1 }}
                
              >
               <AddModeratorIcon />  {intl.get('ASSIGN_ROLLE_ADD')}
              </Button>
              </Fragment>
              }

            {this.state.showassign &&
            <Fragment>
              <Box className="notoppadding" component="form" onSubmit={(e) => this.handleSubmit(e,userdata.id)} sx={{ p: 2 }}>

                              <Grid container spacing={2}>
                                <Grid className="nopaddingleft" item xs={12}>
                              <select className="userselect full" onChange={this.handleChangeRole}>
                                <option key="0" value="">{intl.get('ADMIN_LISTSELECT_ROLLE')}</option>
                              {roles.map(item => {
                                    return (<option key={item.id} value={item.id}>{item.name}</option>)
                                    })
                              }   
                              </select>
                              </Grid>
                              <Grid className="nopaddingleft" item xs={12}>
                              <select className="userselect full" onChange={this.handleChangeTendant}>
                                <option key="0" value="">{intl.get('ADMIN_LISTSELECT_TENANT')}</option>
                              {admintenants.map(tendant => {
                                  return (<option key={tendant.id} value={tendant.id}>{tendant.name}</option>);
                                })
                              }
                              </select>
                              </Grid>
                              {this.state.have_error &&
                                <Fragment>
                                <Alert severity="error">{intl.get('ASSIGN_ROLLE_ERROR')}</Alert>
                                <Button
                                onClick={() => {
                                  this.handleCloseAssignRole()
                                }}
                                fullWidth={true}
                                  variant="outlined"
                                  sx={{ mt: 1, mb: 1 }}
                                > <CloseIcon /> {intl.get('CLOSE')}

                                </Button>
                                </Fragment>
                              }
                              <Grid container spacing={1}>
                              
                              <Grid item xs={12} sm={10} md={6} lg={6} xl={6}>
                              <Button
                              id={"but"+ userdata.id}
                              type="submit"
                              fullWidth={true}
                              variant="outlined"
                              sx={{ mt: 1, mb: 1 }}
                               >
                              <SaveIcon /> 
                              </Button>
                              </Grid>
                              <Grid item xs={12} sm={10} md={6} lg={6} xl={6}>
                              <Button
                                onClick={() => {
                                  this.handleCloseAssignRole()
                                }}
                                fullWidth={true}
                                  variant="outlined"
                                  sx={{ mt: 1, mb: 1 }}
                                > <CloseIcon /> 

                                </Button>
                                </Grid>
                              </Grid>
                              </Grid>
                              </Box>
       
              </Fragment>
              }


          </Box>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken
  });

export default connect(mapStateToProps)(AssignRole);